import { h as t } from "vue";
import c from "./design-system.es58.js";
const m = {
  props: {
    /**
     * Column data representation
     */
    column: Object,
    /**
     * Id of the data field you want to sort by
     */
    sortField: {
      type: String,
      default: ""
    },
    /**
     * Toggle to sort ascending/descending
     */
    sortAscending: Boolean
  },
  render() {
    const { label: s } = this.column;
    let e = s;
    const {
      property: r,
      sortable: o,
      numeric: i,
      expand: n,
      width: l
    } = this.column;
    return o && (e = [
      s,
      t("div", { class: { "sort-arrows": !0 } }, [
        t(
          c,
          {
            name: "arrow-up",
            class: {
              active: this.sortField === r,
              descending: !this.sortAscending
            }
          },
          ""
        )
      ])
    ]), t(
      "th",
      {
        class: {
          sortable: o,
          numeric: i
        },
        style: {
          "min-width": n ? `${l}px` : ""
        }
      },
      [
        t(
          "div",
          {
            class: {
              "active-sortable": this.sortField && this.sortField === r,
              cell: !0
            }
          },
          e
        )
      ]
    );
  }
};
export {
  m as default
};
//# sourceMappingURL=design-system.es324.js.map
